import { Component, OnInit } from '@angular/core';
import { MatExpansionPanel } from '@angular/material';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {
  panelOpenState = false;
  constructor() { }

  ngOnInit() {
  }

  togglePanel(panel: MatExpansionPanel) {
    panel.toggle();
  }

}
